import { Card, Text } from "@mantine/core"
import type { ReactNode } from "react"

export function EmptyState({ children }: { children: ReactNode }) {
  return (
    <Card className="empty-table-state" withBorder radius="sm" p="md">
      <Text c="dimmed" size="sm">
        {children}
      </Text>
    </Card>
  )
}
